module.exports = __webpack_public_path__ + "img/18.58fb3ebf.jpg";